<template>
  <div
    data-testid="phone-overlay-status"
    class="p-4 rounded-lg border"
    role="status"
    :class="
      active
        ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-300 dark:border-amber-700'
        : 'bg-gray-50 dark:bg-gray-800/40 border-gray-200 dark:border-gray-700'
    "
  >
    <div class="flex items-center justify-between gap-4">
      <p
        class="font-semibold"
        :class="active ? 'text-amber-900 dark:text-amber-100' : 'text-gray-700 dark:text-gray-200'"
      >
        <i class="mr-2" :class="active ? 'pi pi-eye' : 'pi pi-eye-slash'" aria-hidden="true"></i>
        {{ active ? "Overlay is showing on phones" : "Overlay is hidden" }}
      </p>
      <p
        v-if="active && templateName"
        data-testid="phone-overlay-template-name"
        class="text-sm shrink-0 text-right text-amber-800 dark:text-amber-200"
      >
        {{ templateName }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: "PhoneOverlayStatus" });

defineProps({
  active: {
    type: Boolean,
    default: false
  },
  templateName: {
    type: String,
    default: ""
  }
});
</script>
